import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@kolmeo/ui-core';
import SVGImage from '../SVGImage';
const PropertyImageFallback = ({ height, width }) => {
    return (_jsx(Box, { width: height, height: width, borderRadius: 5, marginRight: 2, children: _jsx(SVGImage, { type: "house" }) }));
};
export default PropertyImageFallback;
